import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Badge, Dropdown, Menu } from 'antd';

class FiltersMenu extends PureComponent {
  render() {
    const {
      openFilterMenu,
      handleRequestChange,
      filterOptions,
      handleFilter,
      children,
    } = this.props;
    const overlay = (
      <Menu onClick={handleFilter}>
        {filterOptions.map(({ text, filter, badge }) => (
          <Menu.Item key={filter}>
            {badge
              ? <span>{text} <Badge count={badge} size="small" offset={[0, -20]} /></span>
              : text}
          </Menu.Item>
        ))}
      </Menu>
    );
    return (
      <Dropdown
        overlay={overlay}
        visible={openFilterMenu}
        onVisibleChange={handleRequestChange}
        trigger={['click']}
        placement="bottomRight"
      >
        {children}
      </Dropdown>
    );
  }
}

FiltersMenu.propTypes = {
  handleRequestChange: PropTypes.func.isRequired,
  openFilterMenu: PropTypes.bool.isRequired,
  filterOptions: PropTypes.array.isRequired,
  handleFilter: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default FiltersMenu;
